import { useRouter } from 'next/router'

import { FLOW_SPLIT_NAMES, type SplitTreatments } from '@/constants/splits'
import type { AppliedCoupon } from '@/hooks/useCoupon'
import { useLocaleParts } from '@/hooks/useLocaleParts'
import { useSplitTreatments } from '@/hooks/useSplitTreatments'

import type { FlowStepPageConfig } from './types'

export const useFlowFeatureFlags = ({
  config,
  appliedCoupon,
}: {
  config: FlowStepPageConfig
  appliedCoupon: AppliedCoupon | null
}): SplitTreatments => {
  const { query } = useRouter()
  const { language, market } = useLocaleParts()

  const readQueryParam = (key: string) => {
    const value = query[key]
    return typeof value === 'string' ? value : undefined
  }

  return useSplitTreatments({
    names: FLOW_SPLIT_NAMES,
    attributes: {
      flow: config.flowName,
      language,
      market,
      utm_source: readQueryParam('utm_source'),
      utm_medium: readQueryParam('utm_medium'),
      utm_campaign: readQueryParam('utm_campaign'),
      utm_content: readQueryParam('utm_content'),
      utm_term: readQueryParam('utm_term'),
      pd_release: readQueryParam('pd_release'),
      coupon: readQueryParam('coupon') ?? appliedCoupon?.code,
    },
  })
}
